import { useIntl } from 'react-intl';

import { messages } from '../messages';

export const WhiteboardSvg = () => {
	const { formatMessage } = useIntl();
	const label = formatMessage(messages.whiteboardIllustration);

	return (
		<svg width="570" height="640" viewBox="0 0 570 640" fill="none" role="img" aria-label={label}>
			<g clipPath="url(#clip0_7350_60936)">
				<rect width="570" height="640" fill="#F8F8F8" />
				<g clipPath="url(#clip1_7350_60936)">
					<path
						d="M980.785 397.768L872.154 337.168C864.236 349.128 855.884 360.987 847.08 372.729C820.096 408.742 789.032 443.786 753.921 477.543C717.283 512.754 679.238 543.739 640.186 570.564C542.13 637.879 437.371 678.251 331.258 688.941C323.323 724.586 311.029 757.676 294.481 787.675C274.443 823.988 248.171 855.741 215.995 881.999H886.463L980.785 827.897V397.768Z"
						fill="#E9F2FE"
					/>
					<path
						d="M324.904 35.3052C325.824 34.6705 326.744 34.019 327.682 33.3843L232.231 -19.8828H-9.98291V154.384C104.691 149.022 218.565 108.299 324.904 35.3052Z"
						fill="#E9F2FE"
					/>
					<path
						d="M324.036 681.209C324.296 679.939 324.574 678.67 324.835 677.401C325.182 675.663 325.477 673.926 325.807 672.172C326.05 670.903 326.293 669.634 326.519 668.347C326.849 666.41 327.161 664.455 327.474 662.501C327.648 661.399 327.839 660.313 328.012 659.194C328.481 656.12 328.915 653.047 329.315 649.94C331.954 629.746 333.308 608.85 333.308 587.286C333.308 580.053 333.152 572.737 332.839 565.354C331.659 537.209 328.29 510.25 322.855 484.66C306.897 409.528 272.985 346.222 222.959 299.002C172.932 251.798 106.757 220.579 25.7703 209.889C14.1537 208.353 2.22442 207.267 -10 206.582V607.029C82.4993 658.643 178.506 683.447 274.253 683.447C290.853 683.447 307.453 682.679 324.018 681.192L324.036 681.209Z"
						fill="#E9F2FE"
					/>
					<path
						d="M229.053 293.038C280.469 341.562 315.128 406.488 331.363 482.989C336.902 509.047 340.323 536.44 341.521 565.02C341.834 572.52 341.99 579.936 341.99 587.285C341.99 609.184 340.601 630.43 337.927 650.975C337.51 654.132 337.076 657.289 336.59 660.413C336.451 661.365 336.277 662.3 336.121 663.252C335.774 665.424 335.444 667.579 335.062 669.733C334.853 670.936 334.61 672.105 334.402 673.308C334.055 675.195 333.725 677.083 333.343 678.954C333.256 679.421 333.152 679.872 333.065 680.34C436.608 669.399 538.953 629.779 635.133 563.75C673.786 537.209 711.466 506.524 747.775 471.631C782.573 438.174 813.342 403.481 840.031 367.853C848.661 356.328 856.857 344.685 864.636 332.976L335.895 37.9609C333.916 39.3473 331.936 40.7337 329.957 42.1034C222.351 115.966 106.705 157.373 -9.98291 162.735V198.213C2.62352 198.898 14.9521 200.017 26.9682 201.604C109.57 212.495 177.655 244.515 229.053 293.038Z"
						fill="#E9F2FE"
					/>
					<path
						d="M396.757 -19.8828H249.543L335.357 27.99C356.142 13.2573 376.632 -2.71141 396.757 -19.8828Z"
						fill="#E9F2FE"
					/>
					<path
						d="M869.272 325.893C932.235 228.445 965.106 125.102 965.106 21.2733C965.106 7.55978 964.498 -6.1537 963.352 -19.8672H409.763C388.092 -0.975651 365.987 16.4961 343.518 32.5648L869.272 325.893Z"
						fill="#E9F2FE"
					/>
					<path
						d="M286.823 783.751C302.573 755.205 314.398 723.719 322.177 689.778C306.236 691.131 290.261 691.815 274.286 691.815C178.488 691.815 82.3941 667.362 -9.96631 616.684V881.984H202.329C237.352 855.258 265.639 822.169 286.841 783.751H286.823Z"
						fill="#E9F2FE"
					/>
					<path
						d="M337.909 29.4263L343.518 32.5499C365.988 16.4642 388.093 -1.00789 409.764 -19.8831C409.816 -19.9165 409.85 -19.9666 409.903 -20H396.897C396.897 -20 396.81 -19.9165 396.758 -19.8831C376.632 -2.71167 356.142 13.2571 335.356 27.9897L337.926 29.4263H337.909Z"
						fill="#CFE1FD"
					/>
					<path
						d="M335.895 37.9606L327.682 33.3672C326.762 34.0019 325.841 34.6533 324.904 35.2881C218.565 108.299 104.691 149.021 -9.98291 154.383V162.735C106.705 157.373 222.351 115.965 329.939 42.0864C331.919 40.7167 333.898 39.3303 335.878 37.9439L335.895 37.9606Z"
						fill="#CFE1FD"
					/>
					<path
						d="M332.178 609.759C335.217 609.509 338.238 609.208 341.277 608.907C447.407 598.217 552.148 557.862 650.204 490.53C689.274 463.722 727.301 432.737 763.94 397.509C799.05 363.752 830.132 328.708 857.099 292.695C865.903 280.936 874.255 269.077 882.173 257.134L874.654 252.941C866.893 264.65 858.697 276.293 850.049 287.818C823.36 323.446 792.591 358.139 757.793 391.596C721.484 426.506 683.804 457.19 645.151 483.715C548.971 549.744 446.609 589.364 343.083 600.305C342.545 602.961 342.006 605.6 341.433 608.239L332.942 606.502C333.324 604.732 333.689 602.944 334.054 601.174C317.488 602.66 300.888 603.429 284.288 603.429C188.541 603.429 92.5171 578.624 0.0351562 527.011V536.648C92.4129 587.31 188.489 611.78 284.288 611.78C300.263 611.78 316.238 611.096 332.178 609.743V609.759Z"
						fill="#CFE1FD"
					/>
					<path
						d="M222.975 299.001C273.001 346.222 306.914 409.528 322.871 484.659C328.306 510.249 331.675 537.208 332.856 565.353C333.168 572.736 333.325 580.052 333.325 587.285C333.325 608.832 331.97 629.745 329.331 649.939C328.932 653.046 328.497 656.136 328.029 659.193C327.855 660.296 327.664 661.398 327.49 662.5C327.178 664.455 326.865 666.409 326.535 668.347C326.31 669.633 326.066 670.902 325.823 672.172C325.511 673.909 325.198 675.663 324.851 677.4C324.608 678.669 324.313 679.939 324.052 681.208C323.688 682.995 323.323 684.766 322.941 686.537L331.432 688.274C332.005 685.651 332.561 682.995 333.082 680.34C333.168 679.872 333.273 679.421 333.359 678.953C333.724 677.082 334.071 675.195 334.419 673.307C334.644 672.122 334.87 670.936 335.078 669.733C335.46 667.578 335.79 665.423 336.138 663.252C336.294 662.3 336.45 661.365 336.607 660.413C337.075 657.289 337.527 654.132 337.944 650.975C340.635 630.43 342.007 609.183 342.007 587.285C342.007 579.936 341.85 572.519 341.538 565.019C340.34 536.44 336.919 509.046 331.38 482.989C315.144 406.504 280.468 341.561 229.07 293.038C177.672 244.515 109.586 212.494 26.9848 201.604C14.9861 200.017 2.65749 198.898 -9.96631 198.213V206.581C2.25811 207.249 14.1873 208.352 25.804 209.889C106.773 220.595 172.966 251.797 222.992 299.001H222.975Z"
						fill="#CFE1FD"
					/>
					<path
						d="M335.896 37.9608L864.654 332.959L872.173 337.152L980.786 397.769L989.468 402.613L1360.96 609.868L989.468 822.903L980.786 827.881L886.463 881.983H903.411L980.786 837.619L989.468 832.625L1378.1 609.768L989.468 392.958L980.786 388.114L876.792 330.086L869.273 325.894L343.518 32.5656L337.91 29.4253L249.318 -20H232.005L232.231 -19.8831L327.665 33.3673L335.896 37.9608Z"
						fill="#CFE1FD"
					/>
				</g>
				<rect
					x="45"
					y="113.547"
					width="537.07"
					height="619.775"
					rx="12.8652"
					fill="#44546F"
					fillOpacity="0.12"
				/>
				<g clipPath="url(#clip2_7350_60936)">
					<mask id="path-14-inside-1_7350_60936" fill="white">
						<path d="M62 99C62 92.3726 67.3726 87 74 87H602V639H62V99Z" />
					</mask>
					<path d="M62 99C62 92.3726 67.3726 87 74 87H602V639H62V99Z" fill="white" />
					<path
						d="M113 143.4C113 138.761 116.761 135 121.4 135H138.2C142.839 135 146.6 138.761 146.6 143.4V160.2C146.6 164.839 142.839 168.6 138.2 168.6H121.4C116.761 168.6 113 164.839 113 160.2V143.4Z"
						fill="#051524"
						fillOpacity="0.06"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M131.02 145.686C130.271 145.982 129.677 146.543 129.499 147.091L128.001 146.605C128.37 145.469 129.415 144.627 130.441 144.221C131.432 143.83 132.802 143.708 133.685 144.615C134.049 144.989 134.249 145.431 134.261 145.913C134.273 146.371 134.114 146.781 133.922 147.114C133.683 147.527 133.337 147.913 133.002 148.242C134.542 148.098 135.855 148.492 136.595 149.432C137.463 150.535 137.271 152.02 136.325 153.314L135.053 152.386C135.747 151.436 135.637 150.761 135.357 150.406C135.038 150 134.207 149.612 132.708 149.869C132.16 149.963 131.725 150.014 131.409 150.006C131.262 150.002 131.048 149.985 130.846 149.891C130.735 149.839 130.596 149.751 130.484 149.599C130.365 149.437 130.313 149.253 130.311 149.078C130.309 148.779 130.454 148.554 130.518 148.463C130.599 148.345 130.698 148.237 130.787 148.147C130.934 147.998 131.126 147.826 131.311 147.661C131.347 147.629 131.382 147.597 131.417 147.566C131.893 147.139 132.331 146.72 132.558 146.326C132.666 146.14 132.689 146.02 132.687 145.954C132.686 145.912 132.676 145.836 132.557 145.714C132.348 145.499 131.805 145.376 131.02 145.686ZM131.406 148.429C131.406 148.429 131.408 148.429 131.411 148.429C131.408 148.429 131.406 148.429 131.406 148.429ZM125.337 149.175C124.033 149.175 122.975 150.233 122.975 151.538C122.975 152.842 124.033 153.9 125.337 153.9C126.642 153.9 127.7 152.842 127.7 151.538C127.7 150.233 126.642 149.175 125.337 149.175ZM121.4 151.538C121.4 149.363 123.163 147.6 125.337 147.6C127.512 147.6 129.275 149.363 129.275 151.538C129.275 153.712 127.512 155.475 125.337 155.475C123.163 155.475 121.4 153.712 121.4 151.538ZM132.162 152.325C132.439 152.325 132.695 152.47 132.838 152.707L135.988 157.957C136.134 158.201 136.137 158.504 135.998 158.751C135.858 158.997 135.596 159.15 135.312 159.15H129.012C128.729 159.15 128.467 158.997 128.327 158.751C128.187 158.504 128.191 158.201 128.337 157.957L131.487 152.707C131.629 152.47 131.886 152.325 132.162 152.325ZM130.403 157.575H133.922L132.162 154.643L130.403 157.575Z"
						fill="#2898BD"
					/>
					<path
						d="M173.359 152.768H169.17V157.272H173.416C175.252 157.272 176.113 156.555 176.113 155.091C176.113 153.571 175.281 152.768 173.359 152.768ZM172.842 145.394H169.17V149.813H172.842C174.679 149.813 175.425 148.952 175.425 147.546C175.425 146.112 174.621 145.394 172.842 145.394ZM164.551 160.801V141.951H174.22C178.064 141.951 179.929 143.845 179.929 146.886C179.929 149.181 178.867 150.616 176.687 151.104C179.441 151.591 180.761 153.083 180.761 155.723C180.761 158.735 178.724 160.801 174.506 160.801H164.551ZM187.051 153.112V160.801H182.805V146.14H187.051V148.952C187.854 146.972 189.146 145.796 191.441 145.939V150.272C188.457 150.042 187.051 150.759 187.051 153.112ZM196.421 153.456C196.421 156.096 197.368 157.387 199.146 157.387C200.638 157.387 201.987 156.383 201.987 154.059V152.882C201.987 150.53 200.81 149.526 199.319 149.526C197.396 149.526 196.421 150.931 196.421 153.456ZM201.987 160.801V158.19C201.097 160.141 199.491 161.088 197.482 161.088C193.896 161.088 192.203 157.846 192.203 153.456C192.203 149.325 193.925 145.853 197.741 145.853C199.749 145.853 201.183 146.944 201.987 148.694V146.14H206.262V160.801H201.987ZM208.484 142.152C208.484 140.574 209.603 139.656 211.181 139.656C212.759 139.656 213.878 140.574 213.878 142.152C213.878 143.73 212.759 144.62 211.181 144.62C209.603 144.62 208.484 143.73 208.484 142.152ZM209.029 160.801V146.14H213.304V160.801H209.029ZM229.46 152.022V160.801H225.185V152.022C225.185 150.243 224.525 149.468 222.976 149.468C221.398 149.468 220.337 150.501 220.337 152.653V160.801H216.062V146.14H220.337V148.665C221.197 146.857 222.689 145.825 224.726 145.825C227.94 145.825 229.46 148.091 229.46 152.022ZM243.049 156.469C243.049 159.28 241.356 161.116 237.139 161.116C234.815 161.116 232.864 160.571 231.688 159.94V156.296C233.007 156.956 235.245 157.702 237.167 157.702C238.458 157.702 239.118 157.215 239.118 156.469C239.118 155.751 238.516 155.35 236.651 154.919C232.778 154.202 231.487 152.595 231.487 150.3C231.487 147.46 233.61 145.825 237.253 145.825C239.319 145.825 241.241 146.284 242.418 146.915V150.53C240.524 149.726 238.803 149.21 237.196 149.21C235.934 149.21 235.303 149.64 235.303 150.358C235.303 151.017 235.79 151.419 237.827 151.878C241.787 152.653 243.049 154.116 243.049 156.469ZM250.08 155.436C250.08 156.497 250.654 157.1 251.802 157.1C252.289 157.1 252.72 157.014 253.093 156.928V160.686C252.461 160.858 251.773 160.973 250.683 160.973C247.211 160.973 245.834 158.936 245.834 155.923V149.726H244.084V146.14H245.834V143.099H250.08V146.14H253.093V149.726H250.08V155.436ZM261.773 161.145C257.183 161.145 254.515 157.96 254.515 153.456C254.515 148.923 257.183 145.825 261.773 145.825C266.335 145.825 268.974 148.923 268.974 153.456C268.974 157.96 266.335 161.145 261.773 161.145ZM261.773 149.554C259.621 149.554 258.675 151.247 258.675 153.456C258.675 155.665 259.621 157.415 261.773 157.415C263.896 157.415 264.814 155.665 264.814 153.456C264.814 151.247 263.896 149.554 261.773 149.554ZM275.307 153.112V160.801H271.06V146.14H275.307V148.952C276.11 146.972 277.401 145.796 279.696 145.939V150.272C276.712 150.042 275.307 150.759 275.307 153.112ZM294.685 152.653V160.801H290.41V152.022C290.41 150.243 289.75 149.468 288.201 149.468C286.623 149.468 285.562 150.501 285.562 152.653V160.801H281.287V146.14H285.562V148.665C286.422 146.857 287.914 145.825 289.951 145.825C292.275 145.825 293.71 147.001 294.341 149.153C295.173 147.03 296.837 145.825 299.189 145.825C302.345 145.825 303.808 148.034 303.808 152.022V160.801H299.534V152.395C299.534 150.444 298.874 149.468 297.325 149.468C295.747 149.468 294.685 150.501 294.685 152.653ZM320.966 153.456C320.966 150.845 320.019 149.526 318.241 149.526C316.691 149.526 315.4 150.53 315.4 152.882V154.059C315.4 156.383 316.663 157.387 318.097 157.387C319.991 157.387 320.966 156.038 320.966 153.456ZM319.761 161.088C317.81 161.088 316.261 160.141 315.4 158.19V160.801H311.126V140.46H315.4V148.78C316.204 146.972 317.724 145.853 319.819 145.853C323.52 145.853 325.212 149.239 325.212 153.456C325.212 157.76 323.434 161.088 319.761 161.088ZM333.89 161.145C329.3 161.145 326.632 157.96 326.632 153.456C326.632 148.923 329.3 145.825 333.89 145.825C338.452 145.825 341.092 148.923 341.092 153.456C341.092 157.96 338.452 161.145 333.89 161.145ZM333.89 149.554C331.739 149.554 330.792 151.247 330.792 153.456C330.792 155.665 331.739 157.415 333.89 157.415C336.013 157.415 336.932 155.665 336.932 153.456C336.932 151.247 336.013 149.554 333.89 149.554ZM346.735 153.456C346.735 156.096 347.682 157.387 349.461 157.387C350.953 157.387 352.301 156.383 352.301 154.059V152.882C352.301 150.53 351.125 149.526 349.633 149.526C347.711 149.526 346.735 150.931 346.735 153.456ZM352.301 160.801V158.19C351.412 160.141 349.805 161.088 347.797 161.088C344.21 161.088 342.518 157.846 342.518 153.456C342.518 149.325 344.239 145.853 348.055 145.853C350.063 145.853 351.498 146.944 352.301 148.694V146.14H356.576V160.801H352.301ZM363.59 153.112V160.801H359.344V146.14H363.59V148.952C364.393 146.972 365.684 145.796 367.979 145.939V150.272C364.996 150.042 363.59 150.759 363.59 153.112ZM372.96 153.456C372.96 156.096 373.906 157.387 375.685 157.387C377.177 157.387 378.526 156.383 378.526 154.059V152.882C378.526 150.53 377.349 149.526 375.857 149.526C373.935 149.526 372.96 150.931 372.96 153.456ZM378.526 160.801V158.19C377.636 160.141 376.029 161.088 374.021 161.088C370.435 161.088 368.742 157.846 368.742 153.456C368.742 149.325 370.464 145.853 374.279 145.853C376.288 145.853 377.722 146.944 378.526 148.694V140.46H382.8V160.801H378.526Z"
						fill="#292A2E"
					/>
					<g filter="url(#filter0_dd_7350_60936)">
						<rect
							width="80"
							height="79"
							transform="translate(132.654 284.574) rotate(-16.8097)"
							fill="#CCE0FF"
						/>
						<rect
							x="145.725"
							y="300.176"
							width="65"
							height="3"
							rx="1.5"
							transform="rotate(-16.8097 145.725 300.176)"
							fill="#091E42"
							fillOpacity="0.13"
						/>
						<rect
							x="147.75"
							y="306.877"
							width="65"
							height="3"
							rx="1.5"
							transform="rotate(-16.8097 147.75 306.877)"
							fill="#091E42"
							fillOpacity="0.13"
						/>
						<rect
							x="171.791"
							y="306.926"
							width="19"
							height="3"
							rx="1.5"
							transform="rotate(-16.8097 171.791 306.926)"
							fill="#091E42"
							fillOpacity="0.13"
						/>
					</g>
					<path
						d="M201.664 269.939C188.434 274.476 175.483 280.504 163.466 287.793C152.113 294.679 139.392 302.662 134.378 316.2C130.099 327.752 131.474 340.413 136.885 351.708C143.384 365.276 156.191 369.012 169.397 369.98C186.927 371.266 203.891 359.832 215.826 347.782C226.799 336.703 236.968 320.388 239.146 303.931C241.154 288.748 236.901 273.434 225.018 263.424C213.658 253.853 200.866 252.41 187.294 252.399"
						stroke="#9F8FEF"
						strokeWidth="0.845912"
						strokeLinecap="round"
					/>
					<g filter="url(#filter1_dd_7350_60936)">
						<rect
							width="80"
							height="1.69182"
							transform="matrix(0.965926 0.258819 0.258819 -0.965926 448.603 566.223)"
							fill="#EFFFD6"
						/>
					</g>
					<g filter="url(#filter2_d_7350_60936)">
						<rect
							x="458.85"
							y="527.98"
							width="1.11111"
							height="36.9382"
							transform="rotate(15 458.85 527.98)"
							fill="#EFFFD6"
						/>
					</g>
					<g filter="url(#filter3_d_7350_60936)">
						<rect
							x="535.05"
							y="548.398"
							width="1.11111"
							height="36.9382"
							transform="rotate(15 535.05 548.398)"
							fill="#EFFFD6"
						/>
					</g>
					<rect
						x="469.669"
						y="487.6"
						width="80"
						height="81"
						transform="rotate(15 469.669 487.6)"
						fill="#EFFFD6"
					/>
					<rect
						x="469.869"
						y="487.945"
						width="79.4361"
						height="80.4361"
						transform="rotate(15 469.869 487.945)"
						stroke="#388BFF"
						strokeWidth="0.563941"
					/>
					<g clipPath="url(#clip3_7350_60936)">
						<mask id="path-28-inside-2_7350_60936" fill="white">
							<rect
								x="468.672"
								y="485.873"
								width="3.38365"
								height="3.38365"
								rx="0.140985"
								transform="rotate(15 468.672 485.873)"
							/>
						</mask>
						<rect
							x="468.573"
							y="485.7"
							width="3.66562"
							height="3.66562"
							transform="rotate(15 468.573 485.7)"
							fill="#388BFF"
							stroke="white"
							strokeWidth="0.281971"
						/>
					</g>
					<rect
						x="468.672"
						y="485.873"
						width="3.38365"
						height="3.38365"
						rx="0.140985"
						transform="rotate(15 468.672 485.873)"
						stroke="white"
						strokeWidth="0.563941"
						mask="url(#path-28-inside-2_7350_60936)"
					/>
					<g clipPath="url(#clip4_7350_60936)">
						<mask id="path-30-inside-3_7350_60936" fill="white">
							<rect
								x="448"
								y="563.023"
								width="3.38365"
								height="3.38365"
								rx="0.140985"
								transform="rotate(15 448 563.023)"
							/>
						</mask>
						<rect
							x="447.9"
							y="562.851"
							width="3.66562"
							height="3.66562"
							transform="rotate(15 447.9 562.851)"
							fill="#388BFF"
							stroke="white"
							strokeWidth="0.281971"
						/>
					</g>
					<rect
						x="448"
						y="563.023"
						width="3.38365"
						height="3.38365"
						rx="0.140985"
						transform="rotate(15 448 563.023)"
						stroke="white"
						strokeWidth="0.563941"
						mask="url(#path-30-inside-3_7350_60936)"
					/>
					<g clipPath="url(#clip5_7350_60936)">
						<mask id="path-32-inside-4_7350_60936" fill="white">
							<rect
								x="524.729"
								y="583.582"
								width="3.38365"
								height="3.38365"
								rx="0.140985"
								transform="rotate(15 524.729 583.582)"
							/>
						</mask>
						<rect
							x="524.63"
							y="583.409"
							width="3.66562"
							height="3.66562"
							transform="rotate(15 524.63 583.409)"
							fill="#388BFF"
							stroke="white"
							strokeWidth="0.281971"
						/>
					</g>
					<rect
						x="524.729"
						y="583.582"
						width="3.38365"
						height="3.38365"
						rx="0.140985"
						transform="rotate(15 524.729 583.582)"
						stroke="white"
						strokeWidth="0.563941"
						mask="url(#path-32-inside-4_7350_60936)"
					/>
					<g clipPath="url(#clip6_7350_60936)">
						<mask id="path-34-inside-5_7350_60936" fill="white">
							<rect
								x="545.402"
								y="506.432"
								width="3.38365"
								height="3.38365"
								rx="0.140985"
								transform="rotate(15 545.402 506.432)"
							/>
						</mask>
						<rect
							x="545.302"
							y="506.259"
							width="3.66562"
							height="3.66562"
							transform="rotate(15 545.302 506.259)"
							fill="#388BFF"
							stroke="white"
							strokeWidth="0.281971"
						/>
					</g>
					<rect
						x="545.402"
						y="506.432"
						width="3.38365"
						height="3.38365"
						rx="0.140985"
						transform="rotate(15 545.402 506.432)"
						stroke="white"
						strokeWidth="0.563941"
						mask="url(#path-34-inside-5_7350_60936)"
					/>
					<rect
						x="474.33"
						y="506.76"
						width="61.0781"
						height="3"
						rx="1.5"
						transform="rotate(15 474.33 506.76)"
						fill="#091E42"
						fillOpacity="0.13"
					/>
					<rect
						x="472.519"
						y="513.521"
						width="61.0781"
						height="3"
						rx="1.5"
						transform="rotate(15 472.519 513.521)"
						fill="#091E42"
						fillOpacity="0.13"
					/>
					<rect
						x="470.707"
						y="520.283"
						width="61.0781"
						height="3"
						rx="1.5"
						transform="rotate(15 470.707 520.283)"
						fill="#091E42"
						fillOpacity="0.13"
					/>
					<rect
						x="468.895"
						y="527.045"
						width="61.0781"
						height="3"
						rx="1.5"
						transform="rotate(15 468.895 527.045)"
						fill="#091E42"
						fillOpacity="0.13"
					/>
					<rect
						x="467.083"
						y="533.807"
						width="61.0781"
						height="3"
						rx="1.5"
						transform="rotate(15 467.083 533.807)"
						fill="#091E42"
						fillOpacity="0.13"
					/>
					<rect
						x="469.656"
						y="541.742"
						width="52"
						height="3"
						rx="1.5"
						transform="rotate(15 469.656 541.742)"
						fill="#091E42"
						fillOpacity="0.13"
					/>
					<rect x="294.705" y="275.6" width="223" height="4" rx="2" fill="#E8E8E8" />
					<rect x="314.705" y="297.6" width="171" height="4" rx="2" fill="#E8E8E8" />
					<rect x="206.705" y="490.6" width="163" height="112" rx="0.845912" fill="#F4F5F7" />
					<g clipPath="url(#clip7_7350_60936)">
						<g clipPath="url(#clip8_7350_60936)">
							<path
								fillRule="evenodd"
								clipRule="evenodd"
								d="M212.664 493.47C212.615 493.278 212.47 493.127 212.286 493.076C211.953 492.982 210.616 492.982 210.616 492.982C210.616 492.982 209.279 492.982 208.946 493.076C208.762 493.127 208.617 493.278 208.568 493.47C208.479 493.818 208.479 494.544 208.479 494.544C208.479 494.544 208.479 495.27 208.568 495.618C208.617 495.81 208.762 495.961 208.946 496.013C209.279 496.106 210.616 496.106 210.616 496.106C210.616 496.106 211.953 496.106 212.286 496.013C212.47 495.961 212.615 495.81 212.664 495.618C212.753 495.27 212.753 494.544 212.753 494.544C212.753 494.544 212.753 493.818 212.664 493.47Z"
								fill="#FF0000"
							/>
							<path
								fillRule="evenodd"
								clipRule="evenodd"
								d="M210.287 495.12L211.438 494.462L210.287 493.805V495.12Z"
								fill="#FFFFFE"
							/>
						</g>
					</g>
					<g clipPath="url(#clip9_7350_60936)">
						<rect x="208.397" y="499.059" width="159" height="100" rx="0.364617" fill="white" />
						<path
							d="M368.705 528.008C368.705 525.538 366.127 523.849 363.825 524.746C350.19 530.061 310.877 542.895 283.139 526.885C247.889 506.538 226.245 507.27 191.214 530.539C190.277 531.161 189.705 532.223 189.705 533.347L189.705 611.931C189.705 613.8 191.22 615.314 193.089 615.314H365.321C367.19 615.314 368.705 613.8 368.705 611.931V528.008Z"
							fill="url(#paint0_linear_7350_60936)"
						/>
						<g style={{ mixBlendMode: 'darken' }}>
							<g clipPath="url(#clip10_7350_60936)">
								<path
									fillRule="evenodd"
									clipRule="evenodd"
									d="M304.661 540.77C304.236 539.111 302.984 537.804 301.394 537.361C298.513 536.555 286.959 536.555 286.959 536.555C286.959 536.555 275.405 536.555 272.524 537.361C270.934 537.804 269.682 539.111 269.258 540.77C268.485 543.779 268.485 550.055 268.485 550.055C268.485 550.055 268.485 556.331 269.258 559.339C269.682 560.998 270.934 562.305 272.524 562.749C275.405 563.555 286.959 563.555 286.959 563.555C286.959 563.555 298.513 563.555 301.394 562.749C302.984 562.305 304.236 560.998 304.661 559.339C305.433 556.331 305.433 550.055 305.433 550.055C305.433 550.055 305.433 543.779 304.661 540.77Z"
									fill="#2E2E2E"
									fillOpacity="0.8"
								/>
								<path
									fillRule="evenodd"
									clipRule="evenodd"
									d="M284.047 554.759L293.995 549.075L284.047 543.391V554.759Z"
									fill="#FFFFFE"
								/>
							</g>
						</g>
					</g>
					<g filter="url(#filter4_dd_7350_60936)">
						<rect
							width="80"
							height="1.69182"
							transform="matrix(1 0 0 -1 307.705 450.996)"
							fill="#FFEFAE"
						/>
					</g>
					<g filter="url(#filter5_d_7350_60936)">
						<rect x="307.705" y="411.406" width="1.11111" height="36.9382" fill="#FFEFAE" />
					</g>
					<g filter="url(#filter6_d_7350_60936)">
						<rect x="386.594" y="411.406" width="1.11111" height="36.9382" fill="#FFEFAE" />
					</g>
					<rect x="307.705" y="369.6" width="80" height="81" fill="#FFEFAE" />
					<rect
						x="307.987"
						y="369.882"
						width="79.4361"
						height="80.4361"
						stroke="#388BFF"
						strokeWidth="0.563941"
					/>
					<g clipPath="url(#clip11_7350_60936)">
						<mask id="path-56-inside-6_7350_60936" fill="white">
							<rect x="306.295" y="368.189" width="3.38365" height="3.38365" rx="0.140985" />
						</mask>
						<rect
							x="306.154"
							y="368.048"
							width="3.66562"
							height="3.66562"
							fill="#388BFF"
							stroke="white"
							strokeWidth="0.281971"
						/>
					</g>
					<rect
						x="306.295"
						y="368.189"
						width="3.38365"
						height="3.38365"
						rx="0.140985"
						stroke="white"
						strokeWidth="0.563941"
						mask="url(#path-56-inside-6_7350_60936)"
					/>
					<g clipPath="url(#clip12_7350_60936)">
						<mask id="path-58-inside-7_7350_60936" fill="white">
							<rect x="306.295" y="448.062" width="3.38365" height="3.38365" rx="0.140985" />
						</mask>
						<rect
							x="306.154"
							y="447.922"
							width="3.66562"
							height="3.66562"
							fill="#388BFF"
							stroke="white"
							strokeWidth="0.281971"
						/>
					</g>
					<rect
						x="306.295"
						y="448.062"
						width="3.38365"
						height="3.38365"
						rx="0.140985"
						stroke="white"
						strokeWidth="0.563941"
						mask="url(#path-58-inside-7_7350_60936)"
					/>
					<g clipPath="url(#clip13_7350_60936)">
						<mask id="path-60-inside-8_7350_60936" fill="white">
							<rect x="385.731" y="448.062" width="3.38365" height="3.38365" rx="0.140985" />
						</mask>
						<rect
							x="385.59"
							y="447.922"
							width="3.66562"
							height="3.66562"
							fill="#388BFF"
							stroke="white"
							strokeWidth="0.281971"
						/>
					</g>
					<rect
						x="385.731"
						y="448.062"
						width="3.38365"
						height="3.38365"
						rx="0.140985"
						stroke="white"
						strokeWidth="0.563941"
						mask="url(#path-60-inside-8_7350_60936)"
					/>
					<g clipPath="url(#clip14_7350_60936)">
						<mask id="path-62-inside-9_7350_60936" fill="white">
							<rect x="385.731" y="368.189" width="3.38365" height="3.38365" rx="0.140985" />
						</mask>
						<rect
							x="385.59"
							y="368.048"
							width="3.66562"
							height="3.66562"
							fill="#388BFF"
							stroke="white"
							strokeWidth="0.281971"
						/>
					</g>
					<rect
						x="385.731"
						y="368.189"
						width="3.38365"
						height="3.38365"
						rx="0.140985"
						stroke="white"
						strokeWidth="0.563941"
						mask="url(#path-62-inside-9_7350_60936)"
					/>
					<rect
						x="317.166"
						y="400.902"
						width="61.0781"
						height="3"
						rx="1.5"
						fill="#091E42"
						fillOpacity="0.13"
					/>
					<rect
						x="338.205"
						y="407.902"
						width="19"
						height="3"
						rx="1.5"
						fill="#091E42"
						fillOpacity="0.13"
					/>
					<g filter="url(#filter7_dd_7350_60936)">
						<path
							d="M495.762 487.83C496.436 484.211 494.048 480.731 490.43 480.058C488.233 479.649 486.093 480.373 484.595 481.809C483.714 479.93 481.978 478.485 479.782 478.077C476.163 477.403 472.683 479.79 472.01 483.41C471.914 483.923 471.887 484.432 471.909 484.931C471.767 490.753 476.943 497.887 481.143 500.362C485.952 499.563 493.347 494.769 495.307 489.286C495.509 488.828 495.667 488.343 495.762 487.83Z"
							fill="#C9372C"
						/>
						<path
							d="M490.567 479.321C494.592 480.07 497.249 483.941 496.499 487.967C496.396 488.524 496.226 489.048 496.013 489.538L495.911 489.812C494.809 492.642 492.409 495.218 489.738 497.185C486.978 499.216 483.819 500.678 481.266 501.102L480.997 501.147L480.762 501.008C478.533 499.694 476.11 497.194 474.266 494.305C472.428 491.427 471.092 488.049 471.16 484.937C471.138 484.396 471.167 483.838 471.272 483.273C472.022 479.246 475.893 476.59 479.919 477.339C482.024 477.731 483.747 478.98 484.811 480.651C486.404 479.474 488.461 478.929 490.567 479.321Z"
							stroke="white"
							strokeWidth="1.5"
						/>
					</g>
					<path
						d="M492.331 593.357C490.155 608.036 487.963 617.461 485.146 621.773C483.502 624.291 481.014 627.2 476.59 631.25C472.166 635.3 465.777 640.332 458.599 644.918C451.422 649.505 443.648 653.492 436.774 656.562C424.351 662.11 416.474 664.068 413.323 664.546C411.041 664.893 405.994 664.108 399.048 662.709C394.418 661.777 388.997 655.725 381.732 647.414C371.23 635.401 368.504 628.937 368.128 626.941C367.192 621.963 380.412 631.423 382.776 632.024C386.246 632.908 373.873 628.297 371.459 627.425C370.343 627.022 369.011 626.291 367.518 625.629C366.864 625.339 366.283 625.525 365.811 625.917C364.287 628.534 363.107 632.913 362.014 637.317C361.529 639.006 361.185 639.586 360.615 640.443"
						stroke="#9F8FEF"
						strokeLinecap="round"
					/>
					<g filter="url(#filter8_dd_7350_60936)">
						<rect x="375.705" y="439.6" width="30" height="21" rx="10.1509" fill="white" />
						<g clipPath="url(#clip15_7350_60936)">
							<path
								d="M390.415 449.576C390.415 449.436 390.382 449.305 390.326 449.186C389.953 447.984 388.209 448.072 385.729 448.013C385.314 448.004 385.551 447.514 385.697 446.439C385.792 445.74 385.341 444.666 384.583 444.666C383.333 444.666 384.535 445.652 383.431 448.089C382.84 449.391 381.521 448.662 381.521 449.97V452.947C381.521 453.456 381.571 453.946 382.287 454.026C382.981 454.104 382.825 454.599 383.827 454.599H388.839C389.349 454.599 389.765 454.184 389.765 453.673C389.765 453.461 389.69 453.269 389.571 453.112C389.854 452.954 390.048 452.654 390.048 452.307C390.048 452.096 389.975 451.903 389.855 451.747C390.139 451.589 390.334 451.289 390.334 450.942C390.334 450.689 390.232 450.46 390.067 450.293C390.278 450.123 390.415 449.866 390.415 449.576Z"
								fill="#FFDB5E"
							/>
							<path
								d="M387.099 450.502H389.489C389.814 450.502 390.119 450.328 390.285 450.048C390.354 449.933 390.316 449.784 390.2 449.715C390.085 449.647 389.936 449.685 389.867 449.801C389.789 449.934 389.643 450.016 389.489 450.016H387.042C386.799 450.016 386.602 449.819 386.602 449.576C386.602 449.334 386.799 449.137 387.042 449.137H388.677C388.811 449.137 388.92 449.028 388.92 448.893C388.92 448.759 388.811 448.65 388.677 448.65H387.042C386.531 448.65 386.116 449.066 386.116 449.576C386.116 449.861 386.248 450.113 386.45 450.283C386.28 450.451 386.173 450.684 386.173 450.942C386.173 451.228 386.306 451.48 386.51 451.65C386.34 451.818 386.235 452.05 386.235 452.308C386.235 452.619 386.39 452.893 386.626 453.061C386.481 453.225 386.39 453.438 386.39 453.673C386.39 454.184 386.805 454.599 387.315 454.599H388.839C389.164 454.599 389.469 454.426 389.635 454.146C389.704 454.031 389.666 453.882 389.55 453.813C389.435 453.745 389.286 453.782 389.217 453.898C389.138 454.031 388.993 454.113 388.839 454.113H387.315C387.073 454.113 386.876 453.916 386.876 453.673C386.876 453.431 387.073 453.234 387.315 453.234H389.123C389.448 453.234 389.753 453.06 389.919 452.78C389.988 452.665 389.95 452.515 389.834 452.447C389.718 452.377 389.569 452.417 389.501 452.532C389.421 452.667 389.279 452.748 389.123 452.748H387.161C386.918 452.748 386.721 452.55 386.721 452.308C386.721 452.065 386.918 451.868 387.161 451.868H389.408C389.733 451.868 390.039 451.694 390.205 451.415C390.273 451.299 390.235 451.15 390.12 451.082C390.004 451.013 389.855 451.051 389.787 451.166C389.707 451.301 389.565 451.382 389.408 451.382H387.099C386.857 451.382 386.66 451.185 386.66 450.942C386.66 450.7 386.857 450.502 387.099 450.502Z"
								fill="#EE9547"
							/>
						</g>
						<path
							d="M396.716 454.719C396.131 454.719 395.608 454.618 395.148 454.416C394.69 454.215 394.328 453.935 394.061 453.577C393.797 453.216 393.655 452.798 393.635 452.324H394.973C394.99 452.583 395.077 452.807 395.233 452.997C395.392 453.185 395.599 453.33 395.855 453.432C396.111 453.534 396.395 453.585 396.707 453.585C397.051 453.585 397.355 453.526 397.619 453.406C397.886 453.287 398.095 453.121 398.246 452.908C398.396 452.692 398.471 452.443 398.471 452.162C398.471 451.869 398.396 451.612 398.246 451.391C398.098 451.166 397.881 450.99 397.594 450.862C397.309 450.735 396.966 450.671 396.562 450.671H395.825V449.597H396.562C396.886 449.597 397.17 449.539 397.415 449.422C397.662 449.306 397.855 449.144 397.994 448.936C398.133 448.726 398.203 448.48 398.203 448.199C398.203 447.929 398.142 447.695 398.02 447.496C397.9 447.294 397.73 447.137 397.508 447.023C397.29 446.909 397.031 446.852 396.733 446.852C396.449 446.852 396.183 446.905 395.936 447.01C395.692 447.112 395.493 447.26 395.339 447.453C395.186 447.644 395.104 447.872 395.092 448.139H393.818C393.832 447.668 393.971 447.253 394.236 446.895C394.503 446.537 394.855 446.257 395.292 446.056C395.73 445.854 396.216 445.753 396.75 445.753C397.309 445.753 397.792 445.862 398.199 446.081C398.608 446.297 398.923 446.585 399.145 446.946C399.369 447.307 399.48 447.702 399.477 448.131C399.48 448.619 399.344 449.034 399.068 449.375C398.795 449.716 398.432 449.945 397.977 450.061V450.129C398.557 450.218 399.006 450.448 399.324 450.82C399.645 451.192 399.804 451.654 399.801 452.205C399.804 452.685 399.67 453.115 399.4 453.496C399.133 453.877 398.768 454.176 398.305 454.395C397.842 454.611 397.312 454.719 396.716 454.719Z"
							fill="#172B4D"
						/>
					</g>
					<g filter="url(#filter9_dd_7350_60936)">
						<path
							d="M375.002 376.305C374.539 376.305 374.287 376.117 374.156 375.959C374.028 375.803 373.895 375.528 373.988 375.102L376.034 365.76L374.748 365.831H374.738C374.351 365.831 374.069 365.707 373.893 365.493C373.728 365.293 373.669 365.037 373.727 364.773C373.84 364.257 374.39 363.827 374.978 363.796L377.983 363.629C378.042 363.625 378.096 363.623 378.146 363.623C378.256 363.623 378.548 363.623 378.733 363.848C378.922 364.077 378.859 364.369 378.838 364.465L376.495 375.168C376.354 375.818 375.806 376.263 375.095 376.302L375.002 376.305ZM383.059 374.834C381.979 374.834 381.082 374.438 380.464 373.688C379.592 372.63 379.364 371.004 379.806 368.984C380.58 365.446 382.962 362.965 385.732 362.812C386.925 362.746 387.912 363.144 388.577 363.951C389.449 365.009 389.677 366.635 389.236 368.654C388.462 372.191 386.08 374.672 383.308 374.826C383.224 374.832 383.14 374.834 383.059 374.834ZM385.619 364.727L385.516 364.73C384.061 364.812 382.85 366.424 382.276 369.043C381.918 370.682 381.991 371.91 382.48 372.504C382.703 372.775 383.018 372.912 383.417 372.912L383.522 372.909C384.977 372.829 386.188 371.218 386.761 368.598C387.119 366.96 387.047 365.73 386.558 365.136C386.336 364.865 386.02 364.727 385.619 364.727ZM394.312 373.629C393.233 373.629 392.335 373.233 391.716 372.482C390.844 371.424 390.616 369.798 391.057 367.779C391.832 364.24 394.214 361.76 396.984 361.607C398.187 361.541 399.162 361.94 399.827 362.746C400.699 363.804 400.927 365.43 400.485 367.448C399.712 370.984 397.331 373.465 394.559 373.622C394.475 373.628 394.393 373.629 394.312 373.629ZM396.87 363.521L396.768 363.524C395.313 363.606 394.101 365.218 393.529 367.837C393.17 369.476 393.243 370.705 393.732 371.298C393.955 371.569 394.272 371.707 394.671 371.707L394.776 371.704C396.23 371.623 397.441 370.011 398.014 367.392C398.373 365.754 398.301 364.525 397.812 363.931C397.588 363.659 397.272 363.521 396.87 363.521ZM381.955 386.6C381.348 386.6 380.776 386.235 380.551 385.644C380.26 384.884 380.653 384.036 381.428 383.751C381.681 383.658 387.727 381.466 396.83 380.722C397.656 380.651 398.38 381.256 398.449 382.065C398.518 382.875 397.904 383.585 397.079 383.653C388.387 384.363 382.54 386.484 382.481 386.505C382.309 386.569 382.13 386.6 381.955 386.6ZM375.206 382.187C374.603 382.187 374.034 381.828 373.805 381.244C373.508 380.486 373.894 379.635 374.667 379.345C375.074 379.191 384.804 375.576 399.126 374.837C399.96 374.786 400.659 375.417 400.703 376.228C400.747 377.039 400.111 377.731 399.284 377.774C385.467 378.487 375.839 382.054 375.743 382.09C375.566 382.156 375.385 382.187 375.206 382.187Z"
							fill="#CE2E1C"
						/>
						<path
							d="M396.799 380.339C397.83 380.252 398.745 381.008 398.832 382.032C398.92 383.061 398.14 383.951 397.11 384.035C388.464 384.742 382.652 386.851 382.612 386.865L382.613 386.866C382.398 386.945 382.175 386.983 381.955 386.983C381.197 386.983 380.478 386.528 380.192 385.781C379.823 384.816 380.325 383.748 381.296 383.391L381.666 383.262C383.086 382.78 388.396 381.118 395.95 380.413L396.799 380.339ZM399.297 374.451C400.256 374.49 401.034 375.246 401.086 376.207L401.087 376.398C401.041 377.343 400.271 378.107 399.304 378.157C392.423 378.512 386.585 379.578 382.457 380.56C380.393 381.05 378.757 381.519 377.632 381.867C377.07 382.041 376.635 382.186 376.339 382.287C376.191 382.338 376.078 382.378 376 382.405C375.961 382.419 375.932 382.43 375.911 382.438C375.901 382.441 375.892 382.444 375.887 382.446C375.884 382.447 375.881 382.448 375.88 382.448L375.878 382.449L375.876 382.45C375.657 382.532 375.43 382.571 375.206 382.571C374.501 382.571 373.827 382.178 373.507 381.519L373.448 381.384C373.071 380.422 373.563 379.35 374.531 378.985C374.961 378.823 384.731 375.195 399.103 374.453L399.297 374.451ZM378.146 363.239C378.243 363.239 378.717 363.225 379.029 363.604C379.269 363.894 379.262 364.233 379.236 364.419L379.213 364.547L376.87 375.25C376.69 376.084 375.982 376.638 375.116 376.686H375.107L375.014 376.688H375.002C374.491 376.688 374.152 376.501 373.942 376.293L373.86 376.203C373.665 375.967 373.493 375.574 373.612 375.021V375.02L375.55 366.17L374.77 366.214L374.759 366.215H374.738C374.267 366.215 373.864 366.061 373.597 365.737C373.353 365.442 373.27 365.063 373.353 364.689H373.354C373.509 363.98 374.224 363.452 374.956 363.412L377.962 363.245C378.024 363.241 378.086 363.239 378.146 363.239ZM385.952 362.421C387.145 362.413 388.166 362.85 388.873 363.707C389.852 364.895 390.064 366.662 389.61 368.736C388.814 372.375 386.333 375.043 383.329 375.21L383.328 375.209C383.235 375.215 383.145 375.218 383.059 375.218C381.879 375.218 380.868 374.781 380.168 373.933C379.189 372.745 378.977 370.977 379.431 368.902C380.227 365.263 382.708 362.595 385.711 362.429L385.952 362.421ZM396.963 361.224C398.269 361.152 399.37 361.588 400.123 362.501V362.502C401.102 363.689 401.314 365.457 400.86 367.53C400.065 371.166 397.587 373.832 394.585 374.004C394.489 374.011 394.398 374.013 394.312 374.013C393.133 374.013 392.12 373.576 391.42 372.727C390.441 371.539 390.229 369.771 390.683 367.696C391.48 364.056 393.96 361.39 396.963 361.224ZM385.53 365.113C384.953 365.148 384.383 365.487 383.873 366.166C383.36 366.849 382.931 367.85 382.651 369.125C382.477 369.922 382.411 370.602 382.443 371.143C382.476 371.69 382.605 372.052 382.776 372.26V372.261C382.915 372.429 383.113 372.526 383.412 372.527L383.508 372.525C384.086 372.491 384.655 372.154 385.165 371.476C385.678 370.793 386.107 369.791 386.386 368.516C386.56 367.719 386.625 367.039 386.594 366.498C386.562 365.95 386.433 365.588 386.262 365.38L386.261 365.379C386.123 365.211 385.925 365.112 385.623 365.111L385.53 365.113ZM396.782 363.907C396.204 363.942 395.634 364.281 395.124 364.96C394.611 365.643 394.182 366.644 393.903 367.919C393.729 368.716 393.663 369.397 393.695 369.938C393.728 370.485 393.857 370.846 394.028 371.054V371.055C394.15 371.203 394.319 371.297 394.562 371.318L394.671 371.322L394.755 371.32L394.972 371.294C395.477 371.199 395.971 370.866 396.419 370.27C396.932 369.587 397.361 368.585 397.64 367.31C397.814 366.513 397.88 365.833 397.849 365.293C397.821 364.814 397.718 364.476 397.578 364.26L397.516 364.175C397.376 364.005 397.177 363.906 396.874 363.905L396.782 363.907Z"
							stroke="white"
							strokeWidth="0.767576"
						/>
					</g>
					<path
						d="M137.955 363.093C137.41 361.286 136.864 359.479 136.318 357.671C136.057 356.807 135.745 355.925 135.73 355.015C135.716 354.212 135.665 353.27 135.431 352.497C135.365 352.28 135.3 352.063 135.234 351.846C135.117 351.457 135.406 351.965 135.565 352.088C136.502 352.816 137.547 353.324 138.421 354.149C139.196 354.88 139.945 355.687 140.651 356.483C141.643 357.601 142.928 358.258 144.022 359.251C144.593 359.771 144.674 359.963 145.485 359.53C146.378 359.052 147.065 358.299 147.792 357.623C148.399 357.059 149.084 356.583 149.676 356.002C150.255 355.434 150.954 355 151.596 354.502C152.05 354.15 152.438 353.716 152.897 353.373C153.545 352.889 154.178 352.123 154.938 351.81C155.248 351.682 154.888 352.229 154.827 352.421C154.587 353.186 154.29 353.959 153.974 354.698C153.346 356.169 152.626 357.596 151.954 359.048C151.439 360.162 150.811 361.19 150.624 362.41C150.534 362.994 150.252 363.445 150.037 363.986C150.004 364.069 149.821 364.534 149.877 364.487C150.027 364.361 150.144 364.286 150.341 364.389C151.318 364.9 152.122 365.739 152.973 366.418C153.926 367.179 154.862 368.033 155.665 368.949C156.079 369.422 156.435 369.943 156.953 370.316C157.484 370.698 158.244 370.978 158.709 371.4C158.735 371.424 158.983 371.638 158.982 371.649C158.965 371.835 156.701 371.761 156.564 371.764C154.403 371.814 152.246 371.96 150.103 371.634C149.493 371.541 148.887 371.458 148.279 371.354C148.098 371.323 147.455 371.134 147.288 371.201C147.059 371.293 146.708 372.524 146.608 372.737C146.147 373.716 145.587 374.646 145.138 375.637C144.772 376.446 144.38 377.15 143.925 377.912C143.607 378.445 143.162 379.026 142.956 379.609C142.887 379.804 142.363 380.882 142.363 380.882C141.733 379.174 141.474 377.3 141.059 375.533C140.651 373.797 140.553 371.983 140.209 370.232C140.133 369.847 140.046 369.448 140.042 369.057C140.042 369.047 139.817 369.237 139.755 369.264C137.691 370.194 135.145 370.232 132.95 370.053C131.84 369.963 130.743 369.85 129.633 369.772C129.019 369.729 128.417 369.782 127.813 369.754C127.552 369.742 127.329 369.711 127.076 369.787C126.916 369.835 127.965 369.519 128.134 369.467C130.172 368.852 131.99 367.639 133.86 366.649C135.583 365.737 137.167 364.467 139.067 363.893"
						stroke="#B38600"
						strokeWidth="0.845912"
						strokeLinecap="round"
					/>
					<path
						d="M492.67 192.941C492.373 202.296 489.479 211.717 487.837 220.916C486.902 226.155 485.946 231.388 484.967 236.615C484.202 240.696 485.23 237.507 486.529 235.697C493.056 226.605 496.594 214.999 500.227 204.618C502.38 198.466 503.722 192.267 505.604 186.097C506.441 183.354 501.812 185.076 500.808 185.815C498.635 187.414 493.324 192.408 493.324 195.481C493.324 196.944 494.496 197.583 493.324 199.291"
						stroke="#9F8FEF"
						strokeWidth="0.845912"
						strokeLinecap="round"
					/>
					<path
						d="M480.705 249.647C481.646 253.996 490.424 253.329 490.69 249.032C490.874 246.044 489.395 246.207 487.213 244.863C484.594 243.249 479.065 249.504 483.368 251.492"
						stroke="#9F8FEF"
						strokeWidth="0.845912"
						strokeLinecap="round"
					/>
					<g clipPath="url(#clip16_7350_60936)">
						<path
							d="M218.624 605.565C218.044 604.695 218.368 603.438 218.224 602.05C218.075 599.785 217.134 597.591 215.307 595.836L209.085 589.858C209.085 589.858 207.859 588.679 206.718 589.947C205.578 591.214 206.804 592.392 206.804 592.392L209.433 594.919L211.711 597.108C211.711 597.108 211.14 597.742 208.619 595.318L200.102 587.133C200.102 587.133 198.874 585.955 197.734 587.222C196.594 588.489 197.819 589.668 197.819 589.668L205.873 597.408C205.855 597.391 205.264 598.004 205.253 597.994L196.636 589.713C196.636 589.713 195.409 588.534 194.269 589.801C193.128 591.069 194.354 592.247 194.354 592.247L202.972 600.53C202.982 600.54 202.427 601.188 202.444 601.204L195.01 594.059C195.01 594.059 193.784 592.88 192.643 594.147C191.502 595.415 192.729 596.594 192.729 596.594L200.632 604.189C200.704 604.259 200.215 604.971 200.306 605.058L194.611 599.584C194.611 599.584 193.384 598.406 192.244 599.674C191.103 600.942 192.329 602.12 192.329 602.12L201.619 611.044C203.169 612.535 204.762 613.289 206.682 613.565C207.073 613.621 207.573 613.621 207.778 613.648C208.425 613.732 208.994 613.97 209.754 614.452C210.734 615.072 212.203 615.331 213.047 614.398L215.925 611.216L218.583 608.278C219.426 607.346 219.275 606.542 218.624 605.565Z"
							fill="#EF9645"
						/>
						<path
							d="M193.335 614.761C193.122 614.761 192.908 614.677 192.746 614.509C192.42 614.172 192.42 613.628 192.746 613.291L195.705 610.235C196.031 609.898 196.558 609.898 196.883 610.235C197.209 610.572 197.209 611.116 196.883 611.453L193.924 614.51C193.762 614.678 193.548 614.761 193.335 614.761ZM198.957 615.555C198.866 615.555 198.773 615.54 198.681 615.507C198.247 615.35 198.018 614.859 198.17 614.41L198.979 612.022C199.131 611.573 199.607 611.337 200.041 611.493C200.475 611.651 200.704 612.142 200.552 612.59L199.743 614.978C199.623 615.333 199.301 615.555 198.957 615.555ZM192.568 608.953C192.224 608.953 191.903 608.732 191.782 608.379C191.628 607.93 191.856 607.438 192.29 607.28L194.369 606.521C194.805 606.366 195.279 606.599 195.433 607.046C195.586 607.495 195.358 607.987 194.924 608.145L192.845 608.904C192.753 608.937 192.659 608.953 192.568 608.953ZM217.118 590.209C216.904 590.209 216.691 590.125 216.528 589.957C216.203 589.62 216.203 589.075 216.528 588.738L219.488 585.681C219.814 585.346 220.341 585.346 220.667 585.681C220.993 586.017 220.993 586.563 220.667 586.9L217.707 589.957C217.544 590.126 217.331 590.209 217.118 590.209ZM213.648 588.748C213.557 588.748 213.463 588.731 213.373 588.699C212.938 588.542 212.709 588.051 212.861 587.602L213.669 585.214C213.822 584.765 214.296 584.528 214.731 584.685C215.165 584.842 215.394 585.333 215.243 585.782L214.434 588.17C214.314 588.526 213.992 588.748 213.648 588.748ZM218.767 593.72C218.423 593.72 218.102 593.499 217.981 593.145C217.828 592.697 218.056 592.205 218.489 592.047L220.568 591.288C221.003 591.129 221.478 591.366 221.631 591.813C221.784 592.262 221.556 592.754 221.123 592.912L219.044 593.671C218.952 593.704 218.858 593.72 218.767 593.72Z"
							fill="#FA743E"
						/>
						<path
							d="M221.197 605.114C220.646 604.225 221.01 602.979 220.912 601.587C220.837 599.319 219.968 597.093 218.199 595.275L212.176 589.084C212.176 589.084 210.989 587.864 209.807 589.091C208.626 590.317 209.814 591.539 209.814 591.539L212.359 594.155L214.564 596.422C214.564 596.422 213.972 597.035 211.531 594.526C209.089 592.016 203.286 586.048 203.286 586.048C203.286 586.048 202.099 584.828 200.917 586.055C199.735 587.281 200.923 588.501 200.923 588.501L208.719 596.518C208.703 596.501 208.091 597.093 208.08 597.082L199.739 588.505C199.739 588.505 198.551 587.284 197.369 588.511C196.189 589.738 197.375 590.958 197.375 590.958L205.718 599.537C205.728 599.547 205.151 600.175 205.168 600.192L197.972 592.792C197.972 592.792 196.784 591.572 195.603 592.799C194.421 594.026 195.609 595.247 195.609 595.247L203.259 603.114C203.329 603.185 202.818 603.881 202.905 603.971L197.392 598.303C197.392 598.303 196.204 597.082 195.023 598.309C193.841 599.537 195.029 600.758 195.029 600.758L204.02 609.999C205.522 611.543 207.089 612.352 208.999 612.695C209.388 612.765 209.888 612.782 210.091 612.816C210.735 612.923 211.295 613.18 212.041 613.689C212.999 614.342 214.459 614.652 215.334 613.749L218.314 610.67L221.066 607.826C221.94 606.922 221.816 606.113 221.197 605.114Z"
							fill="#FFDB5E"
						/>
					</g>
					<path
						d="M338.537 250.6V241.869H340.219V249.193H344.027V250.6H338.537ZM345.322 250.6V241.869H351.082V243.275H347.004V245.496H350.777V246.885H347.004V249.193H351.1V250.6H345.322ZM352.23 243.275V241.869H359.273V243.275H356.596V250.6H354.914V243.275H352.23ZM360.545 245.449V244.629H360.773C361.016 244.629 361.193 244.557 361.307 244.412C361.42 244.264 361.477 244.055 361.477 243.785V243.416L361.664 243.633H360.545V241.869H362.379V243.709C362.379 244.275 362.24 244.707 361.963 245.004C361.686 245.301 361.283 245.449 360.756 245.449H360.545ZM367.16 250.729C366.473 250.729 365.875 250.623 365.367 250.412C364.859 250.197 364.463 249.885 364.178 249.475C363.893 249.061 363.74 248.555 363.721 247.957H365.367C365.391 248.258 365.48 248.508 365.637 248.707C365.797 248.906 366.008 249.057 366.27 249.158C366.531 249.256 366.824 249.305 367.148 249.305C367.477 249.305 367.766 249.256 368.016 249.158C368.266 249.057 368.461 248.918 368.602 248.742C368.742 248.562 368.812 248.355 368.812 248.121C368.812 247.906 368.75 247.729 368.625 247.588C368.5 247.447 368.322 247.328 368.092 247.23C367.865 247.129 367.592 247.041 367.271 246.967L366.299 246.715C365.564 246.531 364.99 246.248 364.576 245.865C364.162 245.482 363.955 244.979 363.955 244.354C363.955 243.834 364.096 243.379 364.377 242.988C364.658 242.598 365.043 242.295 365.531 242.08C366.02 241.861 366.574 241.752 367.195 241.752C367.828 241.752 368.381 241.861 368.854 242.08C369.33 242.299 369.701 242.602 369.967 242.988C370.236 243.371 370.375 243.812 370.383 244.312H368.754C368.719 243.949 368.561 243.67 368.279 243.475C368.002 243.275 367.633 243.176 367.172 243.176C366.859 243.176 366.59 243.223 366.363 243.316C366.141 243.406 365.969 243.533 365.848 243.697C365.73 243.857 365.672 244.041 365.672 244.248C365.672 244.479 365.74 244.668 365.877 244.816C366.018 244.965 366.197 245.084 366.416 245.174C366.639 245.264 366.869 245.338 367.107 245.396L367.91 245.596C368.258 245.678 368.586 245.787 368.895 245.924C369.207 246.061 369.484 246.23 369.727 246.434C369.969 246.633 370.158 246.873 370.295 247.154C370.432 247.432 370.5 247.758 370.5 248.133C370.5 248.652 370.367 249.107 370.102 249.498C369.84 249.889 369.459 250.191 368.959 250.406C368.463 250.621 367.863 250.729 367.16 250.729ZM378.562 250.717C377.793 250.717 377.105 250.541 376.5 250.189C375.895 249.834 375.416 249.322 375.064 248.654C374.713 247.986 374.537 247.182 374.537 246.24C374.537 245.295 374.713 244.488 375.064 243.82C375.42 243.148 375.9 242.637 376.506 242.285C377.115 241.93 377.801 241.752 378.562 241.752C379.051 241.752 379.506 241.82 379.928 241.957C380.354 242.094 380.73 242.295 381.059 242.561C381.387 242.822 381.656 243.143 381.867 243.521C382.078 243.9 382.217 244.332 382.283 244.816H380.584C380.541 244.566 380.461 244.346 380.344 244.154C380.227 243.963 380.08 243.801 379.904 243.668C379.732 243.531 379.535 243.428 379.312 243.357C379.09 243.287 378.852 243.252 378.598 243.252C378.133 243.252 377.723 243.369 377.367 243.604C377.012 243.834 376.734 244.172 376.535 244.617C376.34 245.062 376.242 245.604 376.242 246.24C376.242 246.885 376.342 247.43 376.541 247.875C376.74 248.316 377.016 248.65 377.367 248.877C377.723 249.104 378.131 249.217 378.592 249.217C378.846 249.217 379.082 249.182 379.301 249.111C379.523 249.041 379.723 248.939 379.898 248.807C380.078 248.67 380.227 248.506 380.344 248.314C380.461 248.119 380.543 247.898 380.59 247.652H382.289C382.238 248.062 382.115 248.451 381.92 248.818C381.725 249.186 381.467 249.514 381.146 249.803C380.826 250.088 380.449 250.312 380.016 250.477C379.582 250.637 379.098 250.717 378.562 250.717ZM387.445 250.717C386.676 250.717 385.984 250.541 385.371 250.189C384.762 249.834 384.279 249.322 383.924 248.654C383.572 247.986 383.396 247.182 383.396 246.24C383.396 245.295 383.572 244.488 383.924 243.82C384.279 243.148 384.762 242.637 385.371 242.285C385.984 241.93 386.676 241.752 387.445 241.752C388.211 241.752 388.898 241.93 389.508 242.285C390.117 242.637 390.598 243.148 390.949 243.82C391.305 244.488 391.482 245.295 391.482 246.24C391.482 247.182 391.305 247.988 390.949 248.66C390.598 249.328 390.117 249.838 389.508 250.189C388.898 250.541 388.211 250.717 387.445 250.717ZM387.445 249.217C387.906 249.217 388.311 249.104 388.658 248.877C389.01 248.646 389.285 248.311 389.484 247.869C389.684 247.424 389.783 246.881 389.783 246.24C389.783 245.592 389.684 245.047 389.484 244.605C389.285 244.16 389.01 243.824 388.658 243.598C388.311 243.367 387.906 243.252 387.445 243.252C386.98 243.252 386.572 243.367 386.221 243.598C385.869 243.824 385.594 244.16 385.395 244.605C385.199 245.051 385.102 245.596 385.102 246.24C385.102 246.881 385.199 247.424 385.395 247.869C385.594 248.311 385.869 248.646 386.221 248.877C386.572 249.104 386.98 249.217 387.445 249.217ZM392.889 250.6V241.869H394.57V249.193H398.379V250.6H392.889ZM399.674 250.6V241.869H401.355V249.193H405.164V250.6H399.674ZM405.914 250.6L408.932 241.869H411.105L414.193 250.6H412.33L410.859 246.234C410.699 245.727 410.533 245.162 410.361 244.541C410.193 243.92 410.012 243.23 409.816 242.473H410.18C409.988 243.234 409.812 243.928 409.652 244.553C409.492 245.178 409.336 245.738 409.184 246.234L407.766 250.6H405.914ZM407.736 248.508V247.172H412.365V248.508H407.736ZM415.318 250.6V241.869H418.723C419.359 241.869 419.889 241.967 420.311 242.162C420.732 242.357 421.049 242.625 421.26 242.965C421.471 243.305 421.576 243.691 421.576 244.125C421.576 244.473 421.508 244.773 421.371 245.027C421.234 245.281 421.049 245.488 420.814 245.648C420.584 245.809 420.322 245.922 420.029 245.988V246.076C420.35 246.092 420.652 246.186 420.938 246.357C421.227 246.529 421.461 246.771 421.641 247.084C421.824 247.396 421.916 247.771 421.916 248.209C421.916 248.662 421.805 249.07 421.582 249.434C421.359 249.793 421.027 250.078 420.586 250.289C420.145 250.496 419.592 250.6 418.928 250.6H415.318ZM417 249.205H418.623C419.174 249.205 419.572 249.1 419.818 248.889C420.068 248.674 420.193 248.398 420.193 248.062C420.193 247.809 420.131 247.582 420.006 247.383C419.885 247.184 419.711 247.027 419.484 246.914C419.258 246.797 418.988 246.738 418.676 246.738H417V249.205ZM417 245.561H418.488C418.754 245.561 418.992 245.514 419.203 245.42C419.414 245.322 419.58 245.186 419.701 245.01C419.822 244.83 419.883 244.617 419.883 244.371C419.883 244.043 419.768 243.775 419.537 243.568C419.307 243.357 418.969 243.252 418.523 243.252H417V245.561ZM427.043 250.717C426.273 250.717 425.582 250.541 424.969 250.189C424.359 249.834 423.877 249.322 423.521 248.654C423.17 247.986 422.994 247.182 422.994 246.24C422.994 245.295 423.17 244.488 423.521 243.82C423.877 243.148 424.359 242.637 424.969 242.285C425.582 241.93 426.273 241.752 427.043 241.752C427.809 241.752 428.496 241.93 429.105 242.285C429.715 242.637 430.195 243.148 430.547 243.82C430.902 244.488 431.08 245.295 431.08 246.24C431.08 247.182 430.902 247.988 430.547 248.66C430.195 249.328 429.715 249.838 429.105 250.189C428.496 250.541 427.809 250.717 427.043 250.717ZM427.043 249.217C427.504 249.217 427.908 249.104 428.256 248.877C428.607 248.646 428.883 248.311 429.082 247.869C429.281 247.424 429.381 246.881 429.381 246.24C429.381 245.592 429.281 245.047 429.082 244.605C428.883 244.16 428.607 243.824 428.256 243.598C427.908 243.367 427.504 243.252 427.043 243.252C426.578 243.252 426.17 243.367 425.818 243.598C425.467 243.824 425.191 244.16 424.992 244.605C424.797 245.051 424.699 245.596 424.699 246.24C424.699 246.881 424.797 247.424 424.992 247.869C425.191 248.311 425.467 248.646 425.818 248.877C426.17 249.104 426.578 249.217 427.043 249.217ZM432.486 250.6V241.869H435.826C436.49 241.869 437.053 241.986 437.514 242.221C437.975 242.455 438.324 242.785 438.562 243.211C438.805 243.633 438.926 244.125 438.926 244.688C438.926 245.254 438.805 245.744 438.562 246.158C438.32 246.572 437.965 246.891 437.496 247.113C437.031 247.332 436.463 247.441 435.791 247.441H433.477V246.064H435.545C435.924 246.064 436.234 246.012 436.477 245.906C436.719 245.801 436.898 245.646 437.016 245.443C437.137 245.236 437.197 244.984 437.197 244.688C437.197 244.383 437.137 244.127 437.016 243.92C436.898 243.709 436.717 243.547 436.471 243.434C436.229 243.32 435.918 243.264 435.539 243.264H434.168V250.6H432.486ZM437.367 250.6L435.246 246.633H437.08L439.242 250.6H437.367ZM439.805 250.6L442.822 241.869H444.996L448.084 250.6H446.221L444.75 246.234C444.59 245.727 444.424 245.162 444.252 244.541C444.084 243.92 443.902 243.23 443.707 242.473H444.07C443.879 243.234 443.703 243.928 443.543 244.553C443.383 245.178 443.227 245.738 443.074 246.234L441.656 250.6H439.805ZM441.627 248.508V247.172H446.256V248.508H441.627ZM447.785 243.275V241.869H454.828V243.275H452.15V250.6H450.469V243.275H447.785ZM456.123 250.6V241.869H461.883V243.275H457.805V245.496H461.578V246.885H457.805V249.193H461.9V250.6H456.123Z"
						fill="#6B6E76"
					/>
					<path
						d="M233.459 231.426L228.462 246.03L243.042 241.01L236.653 237.815L233.459 231.426Z"
						fill="#6A9A23"
					/>
					<rect x="243.042" y="212" width="35.785" height="22.785" rx="11.3925" fill="#6A9A23" />
					<path
						d="M255.358 227.393H253.879V224.719L250.775 219.298H252.45L254.643 223.561L256.836 219.298H258.5L255.358 224.793V227.393ZM260.984 227.528C259.087 227.528 257.978 226.16 257.978 224.275C257.978 222.378 259.087 221.047 260.984 221.047C262.869 221.047 263.978 222.378 263.978 224.275C263.978 226.16 262.869 227.528 260.984 227.528ZM260.984 222.292C259.839 222.292 259.333 223.203 259.333 224.275C259.333 225.347 259.839 226.271 260.984 226.271C262.118 226.271 262.611 225.347 262.611 224.275C262.611 223.203 262.118 222.292 260.984 222.292ZM264.95 224.854V221.171H266.342V224.916C266.342 225.877 266.724 226.296 267.587 226.296C268.437 226.296 269.016 225.742 269.016 224.633V221.171H270.408V227.393H269.016V226.345C268.634 227.097 267.944 227.516 267.094 227.516C265.701 227.516 264.95 226.555 264.95 224.854Z"
						fill="white"
					/>
				</g>
				<path
					d="M60 99C60 91.268 66.268 85 74 85H602V89H74C68.4772 89 64 93.4772 64 99H60ZM64 99M602 639H62H602M60 639V99C60 91.268 66.268 85 74 85V89C68.4772 89 64 93.4772 64 99V639H60ZM64 639M602 87V639V87"
					fill="#0B1228"
					fillOpacity="0.14"
					mask="url(#path-14-inside-1_7350_60936)"
				/>
			</g>
			<defs>
				<filter
					id="filter0_dd_7350_60936"
					x="131.244"
					y="260.876"
					width="102.247"
					height="101.579"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset />
					<feGaussianBlur stdDeviation="0.281971" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0901961 0 0 0 0 0.168627 0 0 0 0 0.301961 0 0 0 0.08 0"
					/>
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7350_60936" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="0.845912" />
					<feGaussianBlur stdDeviation="0.704927" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0901961 0 0 0 0 0.168627 0 0 0 0 0.301961 0 0 0 0.08 0"
					/>
					<feBlend
						mode="normal"
						in2="effect1_dropShadow_7350_60936"
						result="effect2_dropShadow_7350_60936"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect2_dropShadow_7350_60936"
						result="shape"
					/>
				</filter>
				<filter
					id="filter1_dd_7350_60936"
					x="445.219"
					y="561.204"
					width="84.4792"
					height="29.1071"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset />
					<feGaussianBlur stdDeviation="1.69182" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.2 0"
					/>
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7350_60936" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="0.563941" />
					<feGaussianBlur stdDeviation="0.563941" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.06 0"
					/>
					<feBlend
						mode="normal"
						in2="effect1_dropShadow_7350_60936"
						result="effect2_dropShadow_7350_60936"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect2_dropShadow_7350_60936"
						result="shape"
					/>
				</filter>
				<filter
					id="filter2_d_7350_60936"
					x="447.598"
					y="526.571"
					width="13.453"
					height="38.7865"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feMorphology
						radius="0.281971"
						operator="dilate"
						in="SourceAlpha"
						result="effect1_dropShadow_7350_60936"
					/>
					<feOffset dx="-0.281971" />
					<feGaussianBlur stdDeviation="0.563941" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.06 0"
					/>
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7350_60936" />
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_7350_60936"
						result="shape"
					/>
				</filter>
				<filter
					id="filter3_d_7350_60936"
					x="524.362"
					y="546.989"
					width="13.453"
					height="38.7865"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feMorphology
						radius="0.281971"
						operator="dilate"
						in="SourceAlpha"
						result="effect1_dropShadow_7350_60936"
					/>
					<feOffset dx="0.281971" />
					<feGaussianBlur stdDeviation="0.563941" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.06 0"
					/>
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7350_60936" />
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_7350_60936"
						result="shape"
					/>
				</filter>
				<filter
					id="filter4_dd_7350_60936"
					x="304.321"
					y="445.921"
					width="86.7673"
					height="8.4587"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset />
					<feGaussianBlur stdDeviation="1.69182" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.2 0"
					/>
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7350_60936" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="0.563941" />
					<feGaussianBlur stdDeviation="0.563941" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.06 0"
					/>
					<feBlend
						mode="normal"
						in2="effect1_dropShadow_7350_60936"
						result="effect2_dropShadow_7350_60936"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect2_dropShadow_7350_60936"
						result="shape"
					/>
				</filter>
				<filter
					id="filter5_d_7350_60936"
					x="306.013"
					y="409.996"
					width="3.93103"
					height="39.7572"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feMorphology
						radius="0.281971"
						operator="dilate"
						in="SourceAlpha"
						result="effect1_dropShadow_7350_60936"
					/>
					<feOffset dx="-0.281971" />
					<feGaussianBlur stdDeviation="0.563941" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.06 0"
					/>
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7350_60936" />
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_7350_60936"
						result="shape"
					/>
				</filter>
				<filter
					id="filter6_d_7350_60936"
					x="385.466"
					y="409.996"
					width="3.93103"
					height="39.7572"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feMorphology
						radius="0.281971"
						operator="dilate"
						in="SourceAlpha"
						result="effect1_dropShadow_7350_60936"
					/>
					<feOffset dx="0.281971" />
					<feGaussianBlur stdDeviation="0.563941" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.06 0"
					/>
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7350_60936" />
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_7350_60936"
						result="shape"
					/>
				</filter>
				<filter
					id="filter7_dd_7350_60936"
					x="470.1"
					y="476.161"
					width="27.5789"
					height="26.3752"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset />
					<feGaussianBlur stdDeviation="0.15107" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
					/>
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7350_60936" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="0.302139" />
					<feGaussianBlur stdDeviation="0.15107" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
					/>
					<feBlend
						mode="normal"
						in2="effect1_dropShadow_7350_60936"
						result="effect2_dropShadow_7350_60936"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect2_dropShadow_7350_60936"
						result="shape"
					/>
				</filter>
				<filter
					id="filter8_dd_7350_60936"
					x="374.657"
					y="439.18"
					width="32.0957"
					height="23.0957"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset />
					<feGaussianBlur stdDeviation="0.104786" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
					/>
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7350_60936" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="0.628718" />
					<feGaussianBlur stdDeviation="0.523932" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.2 0"
					/>
					<feBlend
						mode="normal"
						in2="effect1_dropShadow_7350_60936"
						result="effect2_dropShadow_7350_60936"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect2_dropShadow_7350_60936"
						result="shape"
					/>
				</filter>
				<filter
					id="filter9_dd_7350_60936"
					x="372.649"
					y="360.544"
					width="29.1113"
					height="27.3987"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset />
					<feGaussianBlur stdDeviation="0.14392" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
					/>
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7350_60936" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="0.287841" />
					<feGaussianBlur stdDeviation="0.14392" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
					/>
					<feBlend
						mode="normal"
						in2="effect1_dropShadow_7350_60936"
						result="effect2_dropShadow_7350_60936"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect2_dropShadow_7350_60936"
						result="shape"
					/>
				</filter>
				<linearGradient
					id="paint0_linear_7350_60936"
					x1="279.205"
					y1="505.343"
					x2="279.205"
					y2="563.891"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#DEEBFF" />
					<stop offset="1" stopColor="#DEEBFF" stopOpacity="0" />
				</linearGradient>
				<clipPath id="clip0_7350_60936">
					<rect width="570" height="640" fill="white" />
				</clipPath>
				<clipPath id="clip1_7350_60936">
					<rect width="1667" height="902" fill="white" transform="translate(-10 -20)" />
				</clipPath>
				<clipPath id="clip2_7350_60936">
					<path d="M62 99C62 92.3726 67.3726 87 74 87H602V639H62V99Z" fill="white" />
				</clipPath>
				<clipPath id="clip3_7350_60936">
					<rect
						x="468.672"
						y="485.873"
						width="3.38365"
						height="3.38365"
						rx="0.140985"
						transform="rotate(15 468.672 485.873)"
						fill="white"
					/>
				</clipPath>
				<clipPath id="clip4_7350_60936">
					<rect
						x="448"
						y="563.023"
						width="3.38365"
						height="3.38365"
						rx="0.140985"
						transform="rotate(15 448 563.023)"
						fill="white"
					/>
				</clipPath>
				<clipPath id="clip5_7350_60936">
					<rect
						x="524.729"
						y="583.582"
						width="3.38365"
						height="3.38365"
						rx="0.140985"
						transform="rotate(15 524.729 583.582)"
						fill="white"
					/>
				</clipPath>
				<clipPath id="clip6_7350_60936">
					<rect
						x="545.402"
						y="506.432"
						width="3.38365"
						height="3.38365"
						rx="0.140985"
						transform="rotate(15 545.402 506.432)"
						fill="white"
					/>
				</clipPath>
				<clipPath id="clip7_7350_60936">
					<rect
						width="4.51153"
						height="4.51153"
						fill="white"
						transform="translate(208.397 492.291)"
					/>
				</clipPath>
				<clipPath id="clip8_7350_60936">
					<rect
						width="4.51153"
						height="3.12337"
						fill="white"
						transform="translate(208.397 492.982)"
					/>
				</clipPath>
				<clipPath id="clip9_7350_60936">
					<rect x="208.397" y="499.059" width="159" height="100" rx="0.364617" fill="white" />
				</clipPath>
				<clipPath id="clip10_7350_60936">
					<rect width="39" height="27" fill="white" transform="translate(267.705 536.287)" />
				</clipPath>
				<clipPath id="clip11_7350_60936">
					<rect
						x="306.295"
						y="368.189"
						width="3.38365"
						height="3.38365"
						rx="0.140985"
						fill="white"
					/>
				</clipPath>
				<clipPath id="clip12_7350_60936">
					<rect
						x="306.295"
						y="448.062"
						width="3.38365"
						height="3.38365"
						rx="0.140985"
						fill="white"
					/>
				</clipPath>
				<clipPath id="clip13_7350_60936">
					<rect
						x="385.731"
						y="448.062"
						width="3.38365"
						height="3.38365"
						rx="0.140985"
						fill="white"
					/>
				</clipPath>
				<clipPath id="clip14_7350_60936">
					<rect
						x="385.731"
						y="368.189"
						width="3.38365"
						height="3.38365"
						rx="0.140985"
						fill="white"
					/>
				</clipPath>
				<clipPath id="clip15_7350_60936">
					<rect width="10" height="10" fill="white" transform="translate(380.705 444.6)" />
				</clipPath>
				<clipPath id="clip16_7350_60936">
					<rect width="30" height="31" fill="white" transform="translate(191.705 584.6)" />
				</clipPath>
			</defs>
		</svg>
	);
};
